module.exports = __webpack_public_path__ + "img/error_icon.905fb04d.svg";